import {action, observable} from 'mobx';

class CalendarState {
  FullCalendar;
  dayGridPlugin;
  timeGridPlugin;
  frLocale;
  agent;

  @observable startDate = new Date().toISOString();
  @observable endDate = new Date().toISOString();

  @observable events = [];
  @observable isLoading = false;
  @observable selectedEvent = {};

  @action async load() {
    const [FullCalendar, dayGridPlugin, timeGridPlugin, frLocale] = await Promise.all([
      import(/* webpackChunkName: 'fullcalendar-core' */ '@fullcalendar/react'),
      import(/* webpackChunkName: 'fullcalendar-daygrid' */ '@fullcalendar/daygrid'),
      import(/* webpackChunkName: 'fullcalendar-timegrid' */ '@fullcalendar/timegrid'),
      import(/* webpackChunkName: 'fullcalendar-frlocale' */ '@fullcalendar/core/locales/fr')
    ]);

    this.FullCalendar = FullCalendar.default;
    this.dayGridPlugin = dayGridPlugin.default;
    this.timeGridPlugin = timeGridPlugin.default;
    this.frLocale = frLocale.default;
  }

  @action setInteractiveAgent(agent) {
    this.agent = agent;
  }

  @action async updateDates(startDate, endDate) {
    this.startDate = startDate;
    this.endDate = endDate;
  }
}

export default CalendarState;
